import { render, staticRenderFns } from "./SegurosTech.vue?vue&type=template&id=2fe833d0&scoped=true"
import script from "./SegurosTech.vue?vue&type=script&lang=js"
export * from "./SegurosTech.vue?vue&type=script&lang=js"
import style0 from "./SegurosTech.vue?vue&type=style&index=0&id=2fe833d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe833d0",
  null
  
)

export default component.exports